export const sortHallAndBooth = (hallAndBooth) => {
  if (!hallAndBooth) return hallAndBooth;

  return [...hallAndBooth].sort((a, b) => {
    const orderA = a.order;
    const orderB = b.order;

    if (orderA === null || orderA === undefined) {
      return (orderB === null || orderB === undefined) ? 0 : 1;
    }
    if (orderB === null || orderB === undefined) {
      return -1;
    }

    return orderA - orderB;
  });
};
